
import React, { useState } from "react";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { useToast } from "@/components/ui/use-toast";

const Participate = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    idea: ""
  });
  const { toast } = useToast();

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Crear el enlace mailto con los datos del formulario
    const mailtoLink = `mailto:marandrada@gmail.com?subject=Nueva idea para El Coto&body=Nombre: ${formData.name}%0D%0AEmail: ${formData.email}%0D%0AIdea: ${formData.idea}`;
    
    // Abrir el cliente de correo del usuario
    window.location.href = mailtoLink;
    
    // Mostrar mensaje de éxito
    toast({
      title: "¡Gracias por tu participación!",
      description: "Tu idea ha sido enviada correctamente.",
    });
    
    // Limpiar el formulario
    setFormData({
      name: "",
      email: "",
      idea: ""
    });
  };

  return (
    <div className="min-h-screen bg-gray-50 py-16 px-4">
      <div className="max-w-3xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-16"
        >
          <h1 className="text-4xl font-bold text-primary mb-4">
            Participa con tus Ideas
          </h1>
          <p className="text-xl text-gray-600">
            Tu opinión es importante para mejorar nuestra comunidad
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="bg-white rounded-lg shadow-lg p-8 mb-8"
        >
          <p className="text-gray-700 leading-relaxed mb-6">
            Queremos escuchar tus ideas, esas que siempre has pensado que podrían transformar nuestra comunidad y mejorar nuestra calidad de vida. Nos comprometemos a revisar cada una de tus propuestas y, si son viables, a impulsarlas o mantenerlas en consideración para cuando las condiciones lo permitan. ¡Te responderemos en cualquier caso!
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
          className="bg-white rounded-lg shadow-lg p-8"
        >
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label htmlFor="name" className="block text-sm font-medium text-gray-700">
                Nombre
              </label>
              <input
                type="text"
                id="name"
                required
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary focus:ring-primary sm:text-sm p-2"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              />
            </div>

            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                Email
              </label>
              <input
                type="email"
                id="email"
                required
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary focus:ring-primary sm:text-sm p-2"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              />
            </div>

            <div>
              <label htmlFor="idea" className="block text-sm font-medium text-gray-700">
                Tu idea
              </label>
              <textarea
                id="idea"
                required
                rows={4}
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary focus:ring-primary sm:text-sm p-2"
                value={formData.idea}
                onChange={(e) => setFormData({ ...formData, idea: e.target.value })}
              />
            </div>

            <Button type="submit" className="w-full">
              Enviar Idea
            </Button>
          </form>
        </motion.div>
      </div>
    </div>
  );
};

export default Participate;
